import * as React from 'react';

import { cn } from '../../lib/utils';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          // One-off layout min height (not a spacing token).
          'flex min-h-20 w-full rounded-md border border-border bg-surface px-3 py-2 text-base md:text-sm placeholder:text-quaternary focus:border-border focus-visible:border-border focus-ring disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        ref={ref}
        data-slot="textarea"
        {...props}
      />
    );
  },
);
Textarea.displayName = 'Textarea';

export { Textarea };
